import Input from '../ui/Input';

const StaffSalaryFields = ({ values, onChange, t }) => (
  <div className="grid gap-3 sm:grid-cols-3">
    <Input
      label={t('staff.salary.daily')}
      type="number"
      min={0}
      value={values.dailyAmount}
      onChange={(e) => onChange((v) => ({ ...v, dailyAmount: e.target.value }))}
      placeholder="0"
    />
    <Input
      label={t('staff.salary.weekly')}
      type="number"
      min={0}
      value={values.weeklyAmount}
      onChange={(e) => onChange((v) => ({ ...v, weeklyAmount: e.target.value }))}
      placeholder="0"
    />
    <Input
      label={t('staff.salary.monthly')}
      type="number"
      min={0}
      value={values.monthlyAmount}
      onChange={(e) => onChange((v) => ({ ...v, monthlyAmount: e.target.value }))}
      placeholder="0"
    />
  </div>
);

export const emptySalaryValues = () => ({
  dailyAmount: '',
  weeklyAmount: '',
  monthlyAmount: '',
});

export const salaryFromApi = (salary = {}) => ({
  dailyAmount: salary.dailyAmount ? String(salary.dailyAmount) : '',
  weeklyAmount: salary.weeklyAmount ? String(salary.weeklyAmount) : '',
  monthlyAmount: salary.monthlyAmount ? String(salary.monthlyAmount) : '',
});

export const salaryToApi = (values) => ({
  dailyAmount: Number(values.dailyAmount) || 0,
  weeklyAmount: Number(values.weeklyAmount) || 0,
  monthlyAmount: Number(values.monthlyAmount) || 0,
});

export default StaffSalaryFields;
